import script from "./CreateLabelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLabelDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateLabelDialog.vue?vue&type=style&index=0&id=ccb4d3ae&lang=css"
import "./CreateLabelDialog.vue?vue&type=style&index=1&id=ccb4d3ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccb4d3ae"]])

export default __exports__